import type { Component, ParentProps } from 'solid-js'
import AsesorWidget from '~/layers/AsesorWidget'
import Footer from '~/layers/Footer'
import Navbar from '~/layers/Navbar'

/**
 * El catálogo público comparte marco con la landing: quien llega por el enlace
 * de un producto puede seguir navegando el sitio, y el asesor queda a mano para
 * preguntar sin salir de la ficha.
 */
const CatalogLayout: Component<ParentProps> = props => {
  return (
    <div class="min-h-screen grid grid-rows-[68px_1fr_auto]">
      <Navbar />
      <main class="grow">{props.children}</main>
      <Footer />
      <AsesorWidget />
    </div>
  )
}

export default CatalogLayout
